import { createAction } from '@reduxjs/toolkit';

const PREFIX = 'mainPage';

export const changeMainPageQuery = createAction<any>(
  `${PREFIX}/changeMainPageQuery`,
);
